import { render, staticRenderFns } from "./TemplateMappings.vue?vue&type=template&id=5d331044&"
import script from "./TemplateMappings.vue?vue&type=script&lang=ts&"
export * from "./TemplateMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports